var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_9263",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_9263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 24.375V7.01937C7.5 6.44396 7.69271 5.96354 8.07812 5.57812C8.46354 5.19271 8.94396 5 9.51937 5H20.4806C21.056 5 21.5365 5.19271 21.9219 5.57812C22.3073 5.96354 22.5 6.44396 22.5 7.01937V24.375L15 21.1538L7.5 24.375Z",
    fill: "#FCFCFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkYes);
export default __webpack_public_path__ + "static/media/bookmark-yes.537a39229fc3cc2b7931970f76a7a3d5.svg";
export { ForwardRef as ReactComponent };